import {Cell, CellId} from '../cell';
import {CellArea} from '../docking/cell-area';
import {CellAreaType} from '../docking/cell-area-type';
import {BoxEdge} from '../edge';
import {CellActionType} from '../layout-actions/cell-action-type';

export class CellActionHistory {

    public cellId: CellId;
    public actionType: CellActionType;

    public targetAreaCellId: CellId;
    public targetAreaType: CellAreaType;
    public targetAreaBoxEdge: BoxEdge;

    constructor(
        cell: Cell,
        actionType: CellActionType,
        targetArea?: CellArea
    ) {
        this.cellId = cell.id;
        this.actionType = actionType;

        if (targetArea) {
            this.targetAreaCellId = targetArea.cell && targetArea.cell.id; // In case of placing a cell to empty layout.
            this.targetAreaType = targetArea.type;
            this.targetAreaBoxEdge = targetArea.boxEdge;
        }
    }

}
